import {
    allRequest,
    deleteRequest,
    getRequest,
    postRequest,
    putRequest,
    REQUEST_METHOD_DELETE
} from "../../../middlewares/api/actions";
import {
    downloadDataflowForMappingHandlerUrl,
    getAgencyNamesUrl,
    getCreateArtefactsUrl,
    getCreateDataflowPublishingContentConstraintUrl,
    getDataBrowserClearCacheUrl,
    getDataflowContentConstraintUrl,
    getDataflowHeader,
    getDataflowHeaderUpdateUrl,
    getDataflowMappingHandlerColumnPreviewUrl,
    getDataflowPublishingDataflowsUrl,
    getDataflowPublishingInfoUrl,
    getDataflowUrl,
    getDeleteArtefactUrl,
    getDsdUrl,
    getHierarchicalCodelistUrl,
    getNodePingUrl,
    getPaginatedCodelistUrl,
    getRemoveDataflowPublishingContentConstraintUrl,
    getSetDataflowPublishingProductionFlagUrl,
    getUpdateArtefactsUrl,
} from "../../../constants/urls";
import {
    getSdmxJsonFromSdmxJsonStructures,
    getSdmxJsonStructureFromArtefact,
    getStringFromArtefactTriplet,
    SDMX_JSON_DATAFLOW_LIST_KEY,
} from "../../../utils/sdmxJson";
import {
    ARTEFACT_TYPE_DDBDATAFLOW,
    DOWNLOAD_FORMAT_TYPE_COMPACT,
    DOWNLOAD_FORMAT_TYPE_GENERIC,
    DOWNLOAD_FORMAT_TYPE_GENERIC20,
    DOWNLOAD_FORMAT_TYPE_CROSSSECTIONAL20,
    DOWNLOAD_FORMAT_TYPE_JSON,
    DOWNLOAD_FORMAT_TYPE_SDMXCSV,
    DOWNLOAD_FORMAT_TYPE_STRUCTURE_SPECIFIC,
    getArtefactDownloadFileSaveNameAndType
} from "../../../constants/download";
import {getHeaderSenderOrReceiver} from "../../data-manager/dataflow-builder/wizard/actions";
import {getFilterObjFromStr, getServerQueryObj} from "../../../utils/filter";
import {convertFilterStrWithSimpleFilterForTimePeriod} from "../../../components/tree-filter/utils";

export const DATAFLOW_PUBLISHING_LIST_DATAFLOW_PUBLISHING_READ = 'DATAFLOW_PUBLISHING_LIST_DATAFLOW_PUBLISHING_READ';
export const DATAFLOW_PUBLISHING_DATAFLOW_EDIT = 'DATAFLOW_PUBLISHING_DATAFLOW_EDIT';
export const DATAFLOW_PUBLISHING_DATAFLOW_DELETE = 'DATAFLOW_PUBLISHING_DATAFLOW_DELETE';
export const DATAFLOW_PUBLISHING_DETAIL_DATAFLOW_READ = 'DATAFLOW_PUBLISHING_DETAIL_DATAFLOW_READ';
export const DATAFLOW_PUBLISHING_DETAIL_DATAFLOW_CHANGE = 'DATAFLOW_PUBLISHING_DETAIL_DATAFLOW_CHANGE';
export const DATAFLOW_PUBLISHING_DETAIL_DATAFLOW_CREATE_SUBMIT = 'DATAFLOW_PUBLISHING_DETAIL_DATAFLOW_CREATE_SUBMIT';
export const DATAFLOW_PUBLISHING_DETAIL_DATAFLOW_UPDATE_SUBMIT = 'DATAFLOW_PUBLISHING_DETAIL_DATAFLOW_UPDATE_SUBMIT';
export const DATAFLOW_PUBLISHING_DETAIL_AGENCIES_READ = 'DATAFLOW_PUBLISHING_DETAIL_AGENCIES_READ';
export const DATAFLOW_PUBLISHING_DETAIL_DSDS_SHOW = 'DATAFLOW_PUBLISHING_DETAIL_DSDS_SHOW';
export const DATAFLOW_PUBLISHING_DETAIL_DSDS_HIDE = 'DATAFLOW_PUBLISHING_DETAIL_DSDS_HIDE';
export const DATAFLOW_PUBLISHING_DETAIL_DSDS_READ = 'DATAFLOW_PUBLISHING_DETAIL_DSDS_READ';
export const DATAFLOW_PUBLISHING_DETAIL_DSD_SET = 'DATAFLOW_PUBLISHING_DETAIL_DSD_SET';
export const DATAFLOW_PUBLISHING_DETAIL_DSD_UNSET = 'DATAFLOW_PUBLISHING_DETAIL_DSD_UNSET';
export const DATAFLOW_PUBLISHING_DETAIL_HIDE = 'DATAFLOW_PUBLISHING_DETAIL_HIDE';
export const DATAFLOW_PUBLISHING_DETAIL_ANNOTATIONS_SHOW = 'DATAFLOW_PUBLISHING_DETAIL_ANNOTATIONS_SHOW';
export const DATAFLOW_PUBLISHING_DETAIL_ANNOTATIONS_HIDE = 'DATAFLOW_PUBLISHING_DETAIL_ANNOTATIONS_HIDE';
export const DATAFLOW_PUBLISHING_DETAIL_LAYOUT_ANNOTATIONS_SHOW = 'DATAFLOW_PUBLISHING_DETAIL_LAYOUT_ANNOTATIONS_SHOW';
export const DATAFLOW_PUBLISHING_DETAIL_LAYOUT_ANNOTATIONS_HIDE = 'DATAFLOW_PUBLISHING_DETAIL_LAYOUT_ANNOTATIONS_HIDE';
export const DATAFLOW_PUBLISHING_SELECTED_DATAFLOW_PUBLISHING_DELETE = 'DATAFLOW_PUBLISHING_SELECTED_DATAFLOW_PUBLISHING_DELETE';
export const DATAFLOW_PUBLISHING_DATAFLOW_DOWNLOAD_SHOW = 'DATAFLOW_PUBLISHING_DATAFLOW_DOWNLOAD_SHOW';
export const DATAFLOW_PUBLISHING_DATAFLOW_DOWNLOAD_HIDE = 'DATAFLOW_PUBLISHING_DATAFLOW_DOWNLOAD_HIDE';
export const DATAFLOW_PUBLISHING_DATAFLOW_DOWNLOAD_CHANGE = 'DATAFLOW_PUBLISHING_DATAFLOW_DOWNLOAD_CHANGE';
export const DATAFLOW_PUBLISHING_DATAFLOW_DOWNLOAD_SUBMIT = 'DATAFLOW_PUBLISHING_DATAFLOW_DOWNLOAD_SUBMIT';
export const DATAFLOW_PUBLISHING_DATAFLOW_CLONE_SHOW = 'DATAFLOW_PUBLISHING_DATAFLOW_CLONE_SHOW';
export const DATAFLOW_PUBLISHING_DATAFLOW_EXPORT_SHOW = 'DATAFLOW_PUBLISHING_DATAFLOW_EXPORT_SHOW';
export const DATAFLOW_PUBLISHING_DETAIL_DSD_FOR_LAYOUT_ANNOTATIONS_READ = 'DATAFLOW_PUBLISHING_DETAIL_DSD_FOR_LAYOUT_ANNOTATIONS_READ';
export const DATAFLOW_PUBLISHING_DATAFLOW_CONTENT_CONSTRAINTS_READ = 'DATAFLOW_PUBLISHING_DATAFLOW_CONTENT_CONSTRAINTS_READ';
export const DATAFLOW_PUBLISHING_DATAFLOW_CONTENT_CONSTRAINTS_HIDE = 'DATAFLOW_PUBLISHING_DATAFLOW_CONTENT_CONSTRAINTS_HIDE';
export const DATAFLOW_PUBLISHING_DETAIL_LAYOUT_ANNOTATIONS_FORM_SHOW = 'DATAFLOW_PUBLISHING_DETAIL_LAYOUT_ANNOTATIONS_FORM_SHOW';
export const DATAFLOW_PUBLISHING_DETAIL_LAYOUT_ANNOTATIONS_FORM_HIDE = 'DATAFLOW_PUBLISHING_DETAIL_LAYOUT_ANNOTATIONS_FORM_HIDE';
export const DATAFLOW_PUBLISHING_DETAIL_LAYOUT_ANNOTATIONS_FORM_SUBMIT = 'DATAFLOW_PUBLISHING_DETAIL_LAYOUT_ANNOTATIONS_FORM_SUBMIT';
export const DATAFLOW_PUBLISHING_DETAIL_LAYOUT_ANNOTATIONS_FORM_RESET = 'DATAFLOW_PUBLISHING_DETAIL_LAYOUT_ANNOTATIONS_FORM_RESET';
export const DATAFLOW_PUBLISHING_DETAIL_LAYOUT_ANNOTATIONS_ITEMS_PAGE_READ = 'DATAFLOW_PUBLISHING_DETAIL_LAYOUT_ANNOTATIONS_ITEMS_PAGE_READ';
export const DATAFLOW_PUBLISHING_DETAIL_LAYOUT_ANNOTATIONS_ITEMS_PAGE_RESET = 'DATAFLOW_PUBLISHING_DETAIL_LAYOUT_ANNOTATIONS_ITEMS_PAGE_RESET';
export const DATAFLOW_PUBLISHING_DETAIL_LINKED_DATAFLOW_ENDPOINT_SET = 'DATAFLOW_PUBLISHING_DETAIL_LINKED_DATAFLOW_ENDPOINT_SET';
export const DATAFLOW_PUBLISHING_DETAIL_LINKED_DATAFLOW_DATAFLOW_SET = 'DATAFLOW_PUBLISHING_DETAIL_LINKED_DATAFLOW_DATAFLOW_SET';
export const DATAFLOW_PUBLISHING_DETAIL_LINKED_DATAFLOW_DATAFLOW_UNSET = 'DATAFLOW_PUBLISHING_DETAIL_LINKED_DATAFLOW_DATAFLOW_UNSET';
export const DATAFLOW_PUBLISHING_DETAIL_LINKED_DATAFLOW_ENDPOINT_PING = 'DATAFLOW_PUBLISHING_DETAIL_LINKED_DATAFLOW_ENDPOINT_PING';
export const DATAFLOW_PUBLISHING_DETAIL_LINKED_DATAFLOW_DATAFLOW_PUBLISHING_MODAL_OPEN = 'DATAFLOW_PUBLISHING_DETAIL_LINKED_DATAFLOW_DATAFLOW_PUBLISHING_MODAL_OPEN';
export const DATAFLOW_PUBLISHING_DETAIL_LINKED_DATAFLOW_DATAFLOW_PUBLISHING_MODAL_CLOSE = 'DATAFLOW_PUBLISHING_DETAIL_LINKED_DATAFLOW_DATAFLOW_PUBLISHING_MODAL_CLOSE';
export const DATAFLOW_PUBLISHING_DETAIL_LINKED_DATAFLOW_DATAFLOW_PUBLISHING_READ = 'DATAFLOW_PUBLISHING_DETAIL_LINKED_DATAFLOW_DATAFLOW_PUBLISHING_READ';

export const DATAFLOW_PUBLISHING_DETAIL_LINKED_SOURCE_DSD_FOR_LAYOUT_ANNOTATIONS_READ = 'DATAFLOW_PUBLISHING_DETAIL_LINKED_SOURCE_DSD_FOR_LAYOUT_ANNOTATIONS_READ';
export const DATAFLOW_PUBLISHING_DETAIL_LINKED_DATAFLOW_SOURCE_READ = 'DATAFLOW_PUBLISHING_DETAIL_LINKED_DATAFLOW_SOURCE_READ';

export const DATAFLOW_PUBLISHING_DETAIL_HIERARCHICAL_CODELISTS_READ = 'DATAFLOW_PUBLISHING_DETAIL_HIERARCHICAL_CODELISTS_READ';
export const DATAFLOW_PUBLISHING_DETAIL_ERASE_MAPPING_SET_INFO = 'DATAFLOW_PUBLISHING_DETAIL_ERASE_MAPPING_SET_INFO';
export const DATAFLOW_PUBLISHING_LIST_DATAFLOW_PRODUCTION_MODAL_SHOW = 'DATAFLOW_PUBLISHING_LIST_DATAFLOW_PRODUCTION_MODAL_SHOW';


export const DATAFLOW_PUBLISHING_LIST_DATAFLOW_CONTENT_CONSTRAINT_UNSET = 'DATAFLOW_PUBLISHING_LIST_DATAFLOW_CONTENT_CONSTRAINT_UNSET';
export const DATAFLOW_PUBLISHING_LIST_DATAFLOW_PRODUCTION_FLAG_SET = 'DATAFLOW_PUBLISHING_LIST_DATAFLOW_PRODUCTION_FLAG_SET';
export const DATAFLOW_PUBLISHING_LIST_DATAFLOW_CONTENT_CONSTRAINT_SET = 'DATAFLOW_PUBLISHING_LIST_DATAFLOW_CONTENT_CONSTRAINT_SET';
export const DATAFLOW_PUBLISHING_LIST_DATAFLOW_PRODUCTION_MODAL_CONTENT_CONSTRAINTS_READ = 'DATAFLOW_PUBLISHING_LIST_DATAFLOW_PRODUCTION_MODAL_CONTENT_CONSTRAINTS_READ';
export const DATAFLOW_PUBLISHING_LIST_DATAFLOW_TRANSCODING_FROM_CC_LIST_READ = 'DATAFLOW_PUBLISHING_LIST_DATAFLOW_TRANSCODING_FROM_CC_LIST_READ';
export const DATAFLOW_PUBLISHING_LIST_DATAFLOW_PRODUCTION_MODAL_HIDE = 'DATAFLOW_PUBLISHING_LIST_DATAFLOW_PRODUCTION_MODAL_HIDE';
export const DATAFLOW_PUBLISHING_LIST_DATAFLOW_PRODUCTION_MODAL_FORCE_CACHE_UPDATE = 'DATAFLOW_PUBLISHING_LIST_DATAFLOW_PRODUCTION_MODAL_FORCE_CACHE_UPDATE';
export const DATAFLOW_PUBLISHING_LIST_DATAFLOW_PRODUCTION_MODAL_DDB_CONTENT_CONSTRAINT_DELETE = 'DATAFLOW_PUBLISHING_LIST_DATAFLOW_PRODUCTION_MODAL_DDB_CONTENT_CONSTRAINT_DELETE';
export const DATAFLOW_PUBLISHING_LIST_DATAFLOW_CONTENT_CONSTRAINT_IS_ALLOWED_CHANGE = 'DATAFLOW_PUBLISHING_LIST_DATAFLOW_CONTENT_CONSTRAINT_IS_ALLOWED_CHANGE';
export const DATAFLOW_PUBLISHING_LIST_DATAFLOW_TRANSCODING_VERIFY_TIMEPERIOD_FORMAT_CHANGE = 'DATAFLOW_PUBLISHING_LIST_DATAFLOW_TRANSCODING_VERIFY_TIMEPERIOD_FORMAT_CHANGE';
export const DATAFLOW_PUBLISHING_LIST_RESET_SUCCESSFUL_FLAG = 'DATAFLOW_PUBLISHING_LIST_RESET_SUCCESSFUL_FLAG';
export const DATAFLOW_PUBLISHING_GET_DATAFLOW_INFO = 'DATAFLOW_PUBLISHING_GET_DATAFLOW_INFO';
export const DATAFLOW_PUBLISHING_CLEAR_DATAFLOW_INFO = 'DATAFLOW_PUBLISHING_CLEAR_DATAFLOW_INFO';
export const DATAFLOW_PUBLISHING_GET_DATAFLOW_HEADER_INFO = 'DATAFLOW_PUBLISHING_GET_DATAFLOW_HEADER_INFO';
export const DATAFLOW_PUBLISHING_CLEAR_DATAFLOW_HEADER_INFO = 'DATAFLOW_PUBLISHING_CLEAR_DATAFLOW_HEADER_INFO';
export const DATAFLOW_PUBLISHING_WIZARD_HEADER_FORM_CHANGE = 'DATAFLOW_PUBLISHING_WIZARD_HEADER_FORM_CHANGE';
export const DATAFLOW_PUBLISHING_WIZARD_HEADER_DELETE = 'DATAFLOW_PUBLISHING_WIZARD_HEADER_DELETE';
export const DATAFLOW_PUBLISHING_FILTER_CONTENT_COSTRAINTS = 'DATAFLOW_PUBLISHING_FILTER_CONTENT_COSTRAINTS';
export const DATAFLOW_PUBLISHING_LIST_DATAFLOW_DOWNLOAD = 'DATAFLOW_PUBLISHING_LIST_DATAFLOW_DOWNLOAD';
export const DATAFLOW_PUBLISHING_LIST_DATAFLOW_DOWNLOAD_CHANGE = 'DATAFLOW_PUBLISHING_LIST_DATAFLOW_DOWNLOAD_CHANGE';
export const DATAFLOW_PUBLISHING_LIST_DATAFLOW_DOWNLOAD_COLUMNS_CHANGE = 'DATAFLOW_PUBLISHING_LIST_DATAFLOW_DOWNLOAD_COLUMNS_CHANGE';
export const DATAFLOW_PUBLISHING_LIST_DATAFLOW_DOWNLOAD_COLUMNS_CHECK = 'DATAFLOW_PUBLISHING_LIST_DATAFLOW_DOWNLOAD_COLUMNS_CHECK';
export const DATAFLOW_PUBLISHING_LIST_DATAFLOW_SHOW_MODAL_DOWNLOAD_QUERY = 'DATAFLOW_PUBLISHING_LIST_DATAFLOW_SHOW_MODAL_DOWNLOAD_QUERY';
export const DATAFLOW_PUBLISHING_LIST_DATAFLOW_DOWNLOAD_DSD_READ = 'DATAFLOW_PUBLISHING_LIST_DATAFLOW_DOWNLOAD_DSD_READ';
export const DATAFLOW_PUBLISHING_LIST_DATAFLOW_DOWNLOAD_HIDE = 'DATAFLOW_PUBLISHING_LIST_DATAFLOW_DOWNLOAD_HIDE';
export const DATAFLOW_PUBLISHING_LIST_DATAFLOW_DOWNLOAD_PREVIEW_SHOW = 'DATAFLOW_PUBLISHING_LIST_DATAFLOW_DOWNLOAD_PREVIEW_SHOW';
export const DATAFLOW_PUBLISHING_LIST_DATAFLOW_DOWNLOAD_QUERY_HIDE = 'DATAFLOW_PUBLISHING_LIST_DATAFLOW_DOWNLOAD_QUERY_HIDE';
export const DATAFLOW_PUBLISHING_LIST_DATAFLOW_DOWNLOAD_QUERY_SET = 'DATAFLOW_PUBLISHING_LIST_DATAFLOW_DOWNLOAD_QUERY_SET';
export const DATAFLOW_PUBLISHING_LIST_DATAFLOW_DOWNLOAD_QUERY_SHOW = 'DATAFLOW_PUBLISHING_LIST_DATAFLOW_DOWNLOAD_QUERY_SHOW';
export const DATAFLOW_PUBLISHING_LIST_DATAFLOW_DOWNLOAD_QUERY_UNSET = 'DATAFLOW_PUBLISHING_LIST_DATAFLOW_DOWNLOAD_QUERY_UNSET';
export const DATAFLOW_PUBLISHING_LIST_DATAFLOW_DOWNLOAD_SHOW = 'DATAFLOW_PUBLISHING_LIST_DATAFLOW_DOWNLOAD_SHOW';
export const DATAFLOW_PUBLISHING_QUERY_FILTER_FORM_COLUMN_VALUES_READ = 'DATAFLOW_PUBLISHING_QUERY_FILTER_FORM_COLUMN_VALUES_READ';
export const DATAFLOW_PUBLISHING_QUERY_TREE_FILTER_COLUMN_FILTERED_VALUES_READ = 'DATAFLOW_PUBLISHING_QUERY_TREE_FILTER_COLUMN_FILTERED_VALUES_READ';
export const DATAFLOW_PUBLISHING_QUERY_FILTER_FORM_COLUMN_VALUES_RESET = 'DATAFLOW_PUBLISHING_QUERY_FILTER_FORM_COLUMN_VALUES_RESET';
export const DATAFLOW_PUBLISHING_QUERY_TOGGLE_PREVIEW = 'DATAFLOW_PUBLISHING_QUERY_TOGGLE_PREVIEW';
export const DATAFLOW_PUBLISHING_QUERY_TREE_FILTER_COLUMN_VALUES_CHANGE = 'DATAFLOW_PUBLISHING_QUERY_TREE_FILTER_COLUMN_VALUES_CHANGE';
export const DATAFLOW_PUBLISHING_QUERY_FILTER_MODAL_SUBMIT = 'DATAFLOW_PUBLISHING_QUERY_FILTER_MODAL_SUBMIT';
export const DATAFLOW_PUBLISHING_QUERY_FILTER_RESET = 'DATAFLOW_PUBLISHING_QUERY_FILTER_RESET';
export const DATAFLOW_PUBLISHING_QUERY_FILTER_RESET_ALL = 'DATAFLOW_PUBLISHING_QUERY_FILTER_RESET_ALL';
export const DATAFLOW_PUBLISHING_QUERY_FILTER_FORM_CHANGE = 'DATAFLOW_PUBLISHING_QUERY_FILTER_FORM_CHANGE';
export const DATAFLOW_PUBLISHING_QUERY_FILTER_FORM_BLOCK_ADD = 'DATAFLOW_PUBLISHING_QUERY_FILTER_FORM_BLOCK_ADD';
export const DATAFLOW_PUBLISHING_QUERY_FILTER_FORM_BLOCK_DELETE = 'DATAFLOW_PUBLISHING_QUERY_FILTER_FORM_BLOCK_DELETE';
export const DATAFLOW_PUBLISHING_QUERY_FILTER_FORM_CONDITION_ADD = 'DATAFLOW_PUBLISHING_QUERY_FILTER_FORM_CONDITION_ADD';
export const DATAFLOW_PUBLISHING_QUERY_FILTER_FORM_CONDITION_DELETE = 'DATAFLOW_PUBLISHING_QUERY_FILTER_FORM_CONDITION_DELETE';
export const DATAFLOW_PUBLISHING_QUERY_TREE_FILTER_CHANGE = 'DATAFLOW_PUBLISHING_QUERY_TREE_FILTER_CHANGE';
export const DATAFLOW_PUBLISHING_QUERY_TREE_FILTER_COLUMN_MODE_CHANGE= 'DATAFLOW_PUBLISHING_QUERY_TREE_FILTER_COLUMN_MODE_CHANGE';

export const changeDataflowPublishingQueryTreeFilterColumnMode = (colName, mode) => ({
    type: DATAFLOW_PUBLISHING_QUERY_TREE_FILTER_COLUMN_MODE_CHANGE,
    colName,
    mode
});

export const changeDataflowPublishingWizardQueryTreeFilter = treeFilter => ({
    type: DATAFLOW_PUBLISHING_QUERY_TREE_FILTER_CHANGE,
    treeFilter
});

export const deleteDataflowPublishingQueryFilterFormCondition =
    (blockIndex, conditionIndex) => ({
        type: DATAFLOW_PUBLISHING_QUERY_FILTER_FORM_CONDITION_DELETE,
        blockIndex,
        conditionIndex
    });

export const addDataflowPublishingQueryFilterFormCondition = blockIndex => ({
    type: DATAFLOW_PUBLISHING_QUERY_FILTER_FORM_CONDITION_ADD,
    blockIndex
});

export const deleteDataflowPublishingQueryFilterFormBlock = blockIndex => ({
    type: DATAFLOW_PUBLISHING_QUERY_FILTER_FORM_BLOCK_DELETE,
    blockIndex
});

export const addDataflowPublishingQueryFilterFormBlock = () => ({
    type: DATAFLOW_PUBLISHING_QUERY_FILTER_FORM_BLOCK_ADD
});

export const changeDataflowPublishingWizardFilterForm = fields => ({
    type: DATAFLOW_PUBLISHING_QUERY_FILTER_FORM_CHANGE,
    fields
});

export const resetAllDataflowPublishingQueryFilter = () => ({
    type: DATAFLOW_PUBLISHING_QUERY_FILTER_RESET_ALL
});

export const resetDataflowPublishingQueryFilter = () => ({
    type: DATAFLOW_PUBLISHING_QUERY_FILTER_RESET
});

export const submitDataflowPublishingWizardQueryFilterModal = (filter, filterStr) => ({
    type: DATAFLOW_PUBLISHING_QUERY_FILTER_MODAL_SUBMIT,
    filter,
    filterStr
});

export const changeDataflowPublishingQueryTreeFilterColumnValues = (colName, values) => ({
    type: DATAFLOW_PUBLISHING_QUERY_TREE_FILTER_COLUMN_VALUES_CHANGE,
    colName,
    values
});

export const toggleDataflowPublishingQueryPreview = value => {
    return {
        type: DATAFLOW_PUBLISHING_QUERY_TOGGLE_PREVIEW,
        showDataflowPreview: value
    }
}

export const resetDataflowPublishingQueryFilterFormColumnValues = columnName => ({
    type: DATAFLOW_PUBLISHING_QUERY_FILTER_FORM_COLUMN_VALUES_RESET,
    columnName
});

export const readDataflowPublishingQueryFilterFormColumnValues = (columnName, dataflowId) => ({
    ...postRequest(
        DATAFLOW_PUBLISHING_QUERY_FILTER_FORM_COLUMN_VALUES_READ,
        getDataflowMappingHandlerColumnPreviewUrl(
            columnName[columnName.length - 1],
            1,
            -1
        ),
        {
            idCube: null,
            dataflowColumns: columnName,
            filter: getServerQueryObj(undefined, getFilterObjFromStr("")).Filter,
            idDataflow: dataflowId
        }
    ),
    colName: columnName[columnName.length - 1],
    forMappingHandler: true
});

export const readDataflowPublishingQueryFilterFormFilterColumnsValues = (columnNames, dataflowId) => ({
    ...postRequest(
        DATAFLOW_PUBLISHING_QUERY_TREE_FILTER_COLUMN_FILTERED_VALUES_READ,
        getDataflowMappingHandlerColumnPreviewUrl(
            columnNames[columnNames.length - 1],
            1,
            -1
        ),
        {
            idCube: null,
            dataflowColumns: columnNames,
            filter: getServerQueryObj(undefined, getFilterObjFromStr("")).Filter,
            idDataflow: dataflowId
        }
    ),
    colName: columnNames[columnNames.length - 1],
    forMappingHandler: true
});

export const showDataflowPublishingListDownloadModal = (dataflowTriplet, dsdTriplet) => ({
    type: DATAFLOW_PUBLISHING_LIST_DATAFLOW_DOWNLOAD_SHOW,
    dataflowTriplet,
    dsdTriplet
});

export const unsetDataflowPublishingListDataflowDownloadQuery = () => ({
    type: DATAFLOW_PUBLISHING_LIST_DATAFLOW_DOWNLOAD_QUERY_UNSET
});

export const checkDataflowPublishingListDataflowDownloadColumns = cols => ({
    type: DATAFLOW_PUBLISHING_LIST_DATAFLOW_DOWNLOAD_COLUMNS_CHECK,
    cols
});

export const changeDataflowPublishingListDataflowDownloadColumns = cols => ({
    type: DATAFLOW_PUBLISHING_LIST_DATAFLOW_DOWNLOAD_COLUMNS_CHANGE,
    cols
});

export const readDataflowPublishingListDataflowDsdDataflow = triplet => getRequest(
    DATAFLOW_PUBLISHING_LIST_DATAFLOW_DOWNLOAD_DSD_READ,
    getDsdUrl(triplet)
);

export const readDataflowPublishingListDataflowDownloadCubeAndDdBDataflow = () => ({
    type: DATAFLOW_PUBLISHING_LIST_DATAFLOW_SHOW_MODAL_DOWNLOAD_QUERY
});

export const hideDataflowPublishingListDataflowDownload = () => ({
    type: DATAFLOW_PUBLISHING_LIST_DATAFLOW_DOWNLOAD_HIDE
});

export const changeDataflowPublishingListDataflowDownload = fields => ({
    type: DATAFLOW_PUBLISHING_LIST_DATAFLOW_DOWNLOAD_CHANGE,
    fields
});

export const hideDataflowPublishingListDataflowDownloadQuery = () => ({
    type: DATAFLOW_PUBLISHING_LIST_DATAFLOW_DOWNLOAD_QUERY_HIDE
});

export const showDataflowPublishingListDataflowDownloadPreview = () => ({
    type: DATAFLOW_PUBLISHING_LIST_DATAFLOW_DOWNLOAD_PREVIEW_SHOW
});

export const showDataflowPublishingListDataflowDownloadQuery = () => ({
    type: DATAFLOW_PUBLISHING_LIST_DATAFLOW_DOWNLOAD_QUERY_SHOW
});

export const setDataflowPublishingListDataflowDownloadQuery = (selCols, filter) => ({
    type: DATAFLOW_PUBLISHING_LIST_DATAFLOW_DOWNLOAD_QUERY_SET,
    selCols,
    filter
});

export const downloadDataflowPublishingListDataflow = (dataflowTriplet, dataflowDownloadParams, sortedSelCols) => {

    const hasFilters =
        dataflowDownloadParams.format === DOWNLOAD_FORMAT_TYPE_GENERIC ||
        dataflowDownloadParams.format === DOWNLOAD_FORMAT_TYPE_STRUCTURE_SPECIFIC ||
        dataflowDownloadParams.format === DOWNLOAD_FORMAT_TYPE_GENERIC20 ||
        dataflowDownloadParams.format === DOWNLOAD_FORMAT_TYPE_CROSSSECTIONAL20 ||
        dataflowDownloadParams.format === DOWNLOAD_FORMAT_TYPE_COMPACT ||
        dataflowDownloadParams.format === DOWNLOAD_FORMAT_TYPE_SDMXCSV ||
        dataflowDownloadParams.format === DOWNLOAD_FORMAT_TYPE_JSON;

    const isSdmx =
        dataflowDownloadParams.format === DOWNLOAD_FORMAT_TYPE_GENERIC ||
        dataflowDownloadParams.format === DOWNLOAD_FORMAT_TYPE_STRUCTURE_SPECIFIC ||
        dataflowDownloadParams.format === DOWNLOAD_FORMAT_TYPE_GENERIC20 ||
        dataflowDownloadParams.format === DOWNLOAD_FORMAT_TYPE_CROSSSECTIONAL20 ||
        dataflowDownloadParams.format === DOWNLOAD_FORMAT_TYPE_COMPACT ||
        dataflowDownloadParams.format === DOWNLOAD_FORMAT_TYPE_SDMXCSV ||
        dataflowDownloadParams.format === DOWNLOAD_FORMAT_TYPE_JSON;

    const data = {
        ...getServerQueryObj(hasFilters && sortedSelCols ? sortedSelCols : null,
            hasFilters
                ? getFilterObjFromStr(
                    isSdmx ? dataflowDownloadParams.filter : convertFilterStrWithSimpleFilterForTimePeriod(dataflowDownloadParams.filter),
                    isSdmx
                )
                : null,
            undefined,
            undefined,
            undefined,
            undefined,
            null,
            null
        ),
        id: dataflowTriplet.id,
        agency: dataflowTriplet.agencyID,
        version: dataflowTriplet.version,
    }
    delete data.iDCube;
    delete data.iDDataflow;
    return {
        ...postRequest(
            DATAFLOW_PUBLISHING_LIST_DATAFLOW_DOWNLOAD,
            downloadDataflowForMappingHandlerUrl(
                dataflowDownloadParams.format === DOWNLOAD_FORMAT_TYPE_SDMXCSV ? 'csv' : dataflowDownloadParams.format,
                dataflowDownloadParams.compression,
            ),
            data,
            undefined,
            undefined,
            true
        ),
        fileSave: getArtefactDownloadFileSaveNameAndType(
            [dataflowTriplet],
            ARTEFACT_TYPE_DDBDATAFLOW,
            dataflowDownloadParams.format,
            dataflowDownloadParams.compression
        )
    }
};

export const dataflowPublishingFilterColumnContentConstraintDetail = (colNames, dataflowId) => ({
    ...postRequest(
        DATAFLOW_PUBLISHING_FILTER_CONTENT_COSTRAINTS,
        getDataflowMappingHandlerColumnPreviewUrl(
            colNames[colNames.length - 1],
            1,
            -1
        ),
        {
            idCube: null,
            dataflowColumns: colNames,
            filter: getServerQueryObj(undefined, getFilterObjFromStr("")).Filter,
            idDataflow: dataflowId
        }
    ),
    colName: colNames[colNames.length - 1]
});

export const deleteCustomHeader = (headerId, dataflowTriplet) => {
    return postRequest(
        DATAFLOW_PUBLISHING_WIZARD_HEADER_DELETE,
        getDataflowHeaderUpdateUrl(dataflowTriplet),
        [],
        t => ({
            success: t('scenes.mappingHandler.DataflowPublishing.headerDeletedSuccessfully')
        })
    )
}

export const saveCustomHeader = (header) => {
    const sdmxHeader = {...header};
    delete sdmxHeader.dataflowTriplet;
    const body = {
        ...sdmxHeader,
        entityId: sdmxHeader.entityId || 0,
        sender: sdmxHeader.sender ? getHeaderSenderOrReceiver(sdmxHeader.sender) : undefined,
        receiver: (sdmxHeader.receiver && sdmxHeader.receiver.organisationId && sdmxHeader.receiver.organisationId.length)
            ? [getHeaderSenderOrReceiver(sdmxHeader.receiver)]
            : undefined,
        dataSetAgencyId: sdmxHeader.dataSetAgencyId,
    };
    return postRequest(
        DATAFLOW_PUBLISHING_CLEAR_DATAFLOW_HEADER_INFO,
        getDataflowHeaderUpdateUrl(header.dataflowTriplet),
        [body],
        t => ({
            success: t('scenes.mappingHandler.DataflowPublishing.headerCreatedSuccessfully')
        })
    )
};

export const changeDataflowPublishingWizardHeaderForm = fields => ({
    type: DATAFLOW_PUBLISHING_WIZARD_HEADER_FORM_CHANGE,
    fields
});

export const clearDataflowPublishingHeaderInfo = () => ({
    type: DATAFLOW_PUBLISHING_CLEAR_DATAFLOW_HEADER_INFO,
});

export const clearDataflowPublishingInfo = () => ({
    type: DATAFLOW_PUBLISHING_CLEAR_DATAFLOW_INFO,
});

export const getDataflowPublishingHeaderInfo = (dataflowTriplet) => ({
    ...getRequest(
        DATAFLOW_PUBLISHING_GET_DATAFLOW_HEADER_INFO,
        getDataflowHeader(dataflowTriplet),
    ),
    dataflowTriplet,
});

export const getDataflowPublishingInfo = (dataflowTriplet) => ({
    ...getRequest(
        DATAFLOW_PUBLISHING_GET_DATAFLOW_INFO,
        getDataflowPublishingInfoUrl(dataflowTriplet),
    ),
    dataflowTriplet,
});

export const dataflowPublishingResetSuccessfulFlag = () => ({
    type: DATAFLOW_PUBLISHING_LIST_RESET_SUCCESSFUL_FLAG,
});

export const unsetDataflowPublishingListDataflowContentConstraint = dataflowTriplet => deleteRequest(
    DATAFLOW_PUBLISHING_LIST_DATAFLOW_CONTENT_CONSTRAINT_UNSET,
    getRemoveDataflowPublishingContentConstraintUrl(dataflowTriplet),
    t => ({
        success: t('scenes.dataManager.dataflowBuilder.list.actions.productionModal.messages.deleteContentConstraints.success')
    })
);

export const setDataflowPublishingListDataflowProductionFlag = (dataflowTriplet, notProductionFlag) => getRequest(
    DATAFLOW_PUBLISHING_LIST_DATAFLOW_PRODUCTION_FLAG_SET,
    getSetDataflowPublishingProductionFlagUrl(dataflowTriplet, notProductionFlag),
    t => ({
        success: notProductionFlag
            ? t('scenes.dataManager.dataflowBuilder.list.actions.productionModal.messages.removePublish.success')
            : t('scenes.dataManager.dataflowBuilder.list.actions.productionModal.messages.publish.success')
    })
);

export const setDataflowPublishingListDataflowContentConstraint = (dataflowTriplet, isAllowed) => getRequest(
    DATAFLOW_PUBLISHING_LIST_DATAFLOW_CONTENT_CONSTRAINT_SET,
    getCreateDataflowPublishingContentConstraintUrl(dataflowTriplet, isAllowed),
    t => ({
        success: t('scenes.dataManager.dataflowBuilder.list.actions.productionModal.messages.createContentConstraints.success')
    })
);

export const readDataflowProductionModalDataflowContentConstraints = dataflowTriplet => getRequest(
    DATAFLOW_PUBLISHING_LIST_DATAFLOW_PRODUCTION_MODAL_CONTENT_CONSTRAINTS_READ,
    getDataflowContentConstraintUrl(dataflowTriplet)
);

export const hideDataflowPublishingListDataflowProductionModal = () => ({
    type: DATAFLOW_PUBLISHING_LIST_DATAFLOW_PRODUCTION_MODAL_HIDE,
});

export const forceDataflowPublishingListDataflowCacheUpdate = dataflowTriplet => postRequest(
    DATAFLOW_PUBLISHING_LIST_DATAFLOW_PRODUCTION_MODAL_FORCE_CACHE_UPDATE,
    getDataBrowserClearCacheUrl(dataflowTriplet.id, dataflowTriplet.agencyID, dataflowTriplet.version),
    undefined,
    t => ({
        success: t('scenes.dataManager.dataflowBuilder.list.actions.productionModal.messages.forceCacheUpdate.success')
    })
);

export const deleteDataflowProductionModalDDBContentConstraints = contentConstraintTriplet => deleteRequest(
    DATAFLOW_PUBLISHING_LIST_DATAFLOW_PRODUCTION_MODAL_DDB_CONTENT_CONSTRAINT_DELETE,
    getDeleteArtefactUrl("ContentConstraint", contentConstraintTriplet),
    t => ({
        success: t('scenes.dataManager.dataflowBuilder.list.actions.productionModal.messages.deleteDDBCC.success')
    })
);

export const changeDataflowPublishingListDataflowContentConstraintIsAllowed = isAllowed => ({
    type: DATAFLOW_PUBLISHING_LIST_DATAFLOW_CONTENT_CONSTRAINT_IS_ALLOWED_CHANGE,
    isAllowed
});

export const changeVerifyTimePeriodFormat = verifyTimePeriodFormat => ({
    type: DATAFLOW_PUBLISHING_LIST_DATAFLOW_TRANSCODING_VERIFY_TIMEPERIOD_FORMAT_CHANGE,
    verifyTimePeriodFormat
});

export const showDataflowPublishingListDataflowProductionModal = (dataflowTriplet) => ({
    type: DATAFLOW_PUBLISHING_LIST_DATAFLOW_PRODUCTION_MODAL_SHOW,
    dataflowTriplet
});

export const dataflowsEraseMappingSetInfo = () => ({
    type: DATAFLOW_PUBLISHING_DETAIL_ERASE_MAPPING_SET_INFO,
});

export const setDataflowsDetailLinkedDataflowEndpoint = endpointId => ({
    type: DATAFLOW_PUBLISHING_DETAIL_LINKED_DATAFLOW_ENDPOINT_SET,
    endpointId
});

export const setDataflowsDetailLinkedDataflowDataflow = (dataflowTriplet) => ({
    type: DATAFLOW_PUBLISHING_DETAIL_LINKED_DATAFLOW_DATAFLOW_SET,
    dataflowTriplet
});

export const unsetDataflowsDetailLinkedDataflowDataflow = () => ({
    type: DATAFLOW_PUBLISHING_DETAIL_LINKED_DATAFLOW_DATAFLOW_UNSET
});

export const pingDataflowsDetailLinkedDataflowEndpoint = endpointId => getRequest(
    DATAFLOW_PUBLISHING_DETAIL_LINKED_DATAFLOW_ENDPOINT_PING,
    getNodePingUrl(),
    undefined,
    undefined,
    endpointId
);

export const openDataflowsDetailLinkedDataflowDataflowsModal = () => ({
    type: DATAFLOW_PUBLISHING_DETAIL_LINKED_DATAFLOW_DATAFLOW_PUBLISHING_MODAL_OPEN
});

export const closeDataflowsDetailLinkedDataflowDataflowsModal = () => ({
    type: DATAFLOW_PUBLISHING_DETAIL_LINKED_DATAFLOW_DATAFLOW_PUBLISHING_MODAL_CLOSE
});

export const readDataflowsDetailLinkedDataflowDataflows = endpointId => getRequest(
    DATAFLOW_PUBLISHING_DETAIL_LINKED_DATAFLOW_DATAFLOW_PUBLISHING_READ,
    getDataflowUrl(),
    undefined,
    undefined,
    endpointId
);

export const readDataflowsListDataflows = () => getRequest(
    DATAFLOW_PUBLISHING_LIST_DATAFLOW_PUBLISHING_READ,
    getDataflowPublishingDataflowsUrl()
);

export const editDataflowsDataflow = dataflowTriplet => ({
    type: DATAFLOW_PUBLISHING_DATAFLOW_EDIT,
    dataflowTriplet
});

export const deleteDataflowsDataflow = dataflowTriplet => deleteRequest(
    DATAFLOW_PUBLISHING_DATAFLOW_DELETE,
    getDeleteArtefactUrl("Dataflow", dataflowTriplet),
    t => ({
        success: t('scenes.metaManager.commons.messages.delete.success')
    })
);

export const readDataflowsDetailDataflow = dataflowTriplet => getRequest(
    DATAFLOW_PUBLISHING_DETAIL_DATAFLOW_READ,
    getDataflowUrl(dataflowTriplet)
);

export const changeDataflowsDetailDataflow = fields => ({
    type: DATAFLOW_PUBLISHING_DETAIL_DATAFLOW_CHANGE,
    fields
});

export const submitDataflowsDetailDataflowCreate = dataflow => postRequest(
    DATAFLOW_PUBLISHING_DETAIL_DATAFLOW_CREATE_SUBMIT,
    getCreateArtefactsUrl(),
    getSdmxJsonFromSdmxJsonStructures(
        [getSdmxJsonStructureFromArtefact(dataflow)],
        SDMX_JSON_DATAFLOW_LIST_KEY
    ),
    t => ({
        success: t('scenes.metaManager.dataflows.messages.create.success')
    })
);

export const submitDataflowsDetailDataflowUpdate = (dataflow, keepModalOpen) => {

    return ({
        ...putRequest(
            DATAFLOW_PUBLISHING_DETAIL_DATAFLOW_UPDATE_SUBMIT,
            getUpdateArtefactsUrl(),
            getSdmxJsonFromSdmxJsonStructures(
                [getSdmxJsonStructureFromArtefact(dataflow)],
                SDMX_JSON_DATAFLOW_LIST_KEY
            ),
            t => ({
                success: t('scenes.metaManager.dataflows.messages.update.success')
            })
        ),
        keepModalOpen
    })
};

export const readDataflowsDetailAgencies = allowedAgencies => ({
    ...getRequest(
        DATAFLOW_PUBLISHING_DETAIL_AGENCIES_READ,
        getAgencyNamesUrl()
    ),
    allowedAgencies
});

export const showDataflowsDetailDsds = () => ({
    type: DATAFLOW_PUBLISHING_DETAIL_DSDS_SHOW
});

export const hideDataflowsDetailDsds = () => ({
    type: DATAFLOW_PUBLISHING_DETAIL_DSDS_HIDE
});

export const readDataflowsDetailDsds = () => getRequest(
    DATAFLOW_PUBLISHING_DETAIL_DSDS_READ,
    getDsdUrl(null, true)
);

export const setDataflowsDetailDsd = dsdTriplet => ({
    type: DATAFLOW_PUBLISHING_DETAIL_DSD_SET,
    dsdTriplet
});

export const unsetDataflowsDetailDsd = () => ({
    type: DATAFLOW_PUBLISHING_DETAIL_DSD_UNSET
});

export const hideDataflowsDetail = () => ({
    type: DATAFLOW_PUBLISHING_DETAIL_HIDE
});

export const showDataflowsDetailAnnotations = (annotations, triplet) => ({
    type: DATAFLOW_PUBLISHING_DETAIL_ANNOTATIONS_SHOW,
    annotations,
    triplet
});

export const hideDataflowsDetailAnnotations = () => ({
    type: DATAFLOW_PUBLISHING_DETAIL_ANNOTATIONS_HIDE
});

export const showDataflowsDetailLayoutAnnotations = (annotations, triplet) => ({
    type: DATAFLOW_PUBLISHING_DETAIL_LAYOUT_ANNOTATIONS_SHOW,
    annotations,
    triplet
});

export const hideDataflowsDetailLayoutAnnotations = () => ({
    type: DATAFLOW_PUBLISHING_DETAIL_LAYOUT_ANNOTATIONS_HIDE
});

export const deleteDataflowsSelectedDataflows = dataflowTriplets => allRequest(
    DATAFLOW_PUBLISHING_SELECTED_DATAFLOW_PUBLISHING_DELETE,
    dataflowTriplets.map(() => REQUEST_METHOD_DELETE),
    dataflowTriplets.map(triplet => getDeleteArtefactUrl("Dataflow", triplet)),
    null,
    t => ({
        success: t('scenes.metaManager.commons.messages.multiDelete.success')
    }),
    dataflowTriplets.map(getStringFromArtefactTriplet)
);

export const showDataflowsDataflowDownload = (artefactTriplets, lang) => ({
    type: DATAFLOW_PUBLISHING_DATAFLOW_DOWNLOAD_SHOW,
    artefactTriplets,
    lang
});

export const showDataflowsDataflowClone = srcTriplet => ({
    type: DATAFLOW_PUBLISHING_DATAFLOW_CLONE_SHOW,
    srcTriplet
});

export const showDataflowsDataflowExport = sourceTriplet => ({
    type: DATAFLOW_PUBLISHING_DATAFLOW_EXPORT_SHOW,
    sourceTriplet
});

export const readDataflowsDetailDsdForLayoutAnnotations = dsdTriplet => getRequest(
    DATAFLOW_PUBLISHING_DETAIL_DSD_FOR_LAYOUT_ANNOTATIONS_READ,
    getDsdUrl(dsdTriplet, true)
);

export const hideDataflowsDataflowContentConstraints = () => ({
    type: DATAFLOW_PUBLISHING_DATAFLOW_CONTENT_CONSTRAINTS_HIDE
});

export const readDataflowsDataflowContentConstraints = dataflowTriplet => getRequest(
    DATAFLOW_PUBLISHING_DATAFLOW_CONTENT_CONSTRAINTS_READ,
    getDataflowContentConstraintUrl(dataflowTriplet)
);

export const showDataflowsDetailLayoutAnnotationsForm = () => ({
    type: DATAFLOW_PUBLISHING_DETAIL_LAYOUT_ANNOTATIONS_FORM_SHOW
});

export const hideDataflowsDetailLayoutAnnotationsForm = () => ({
    type: DATAFLOW_PUBLISHING_DETAIL_LAYOUT_ANNOTATIONS_FORM_HIDE
});

export const submitDataflowsDetailLayoutAnnotationsForm = annotations => ({
    type: DATAFLOW_PUBLISHING_DETAIL_LAYOUT_ANNOTATIONS_FORM_SUBMIT,
    annotations
});

export const resetDataflowsDetailLayoutAnnotationsForm = () => ({
    type: DATAFLOW_PUBLISHING_DETAIL_LAYOUT_ANNOTATIONS_FORM_RESET
});

export const readDataflowsDetailLayoutAnnotationsItemsPage = ({
                                                                  codelistTriplet,
                                                                  language,
                                                                  pageNum,
                                                                  pageSize,
                                                                  searchText,
                                                                  filters,
                                                                  sortCol,
                                                                  sortByDesc,
                                                                  columnName
                                                              }) => ({
    ...postRequest(
        DATAFLOW_PUBLISHING_DETAIL_LAYOUT_ANNOTATIONS_ITEMS_PAGE_READ,
        getPaginatedCodelistUrl(),
        ({
            Id: codelistTriplet.id,
            AgencyId: codelistTriplet.agencyID,
            Version: codelistTriplet.version,
            Lang: language,
            PageNum: pageNum,
            PageSize: pageSize,
            AllSearch: searchText,
            CodeSearch: filters.id ? filters.id : undefined,
            NameSearch: filters.name ? filters.name : undefined,
            ParentSearch: filters.parent ? filters.parent : undefined,
            SortColumn: sortCol ? sortCol : undefined,
            SortDesc: sortByDesc ? sortByDesc : undefined,
            rebuildDb: false
        })
    ),
    columnName,
});

export const resetDataflowsDetailLayoutAnnotationsItemsPage = () => ({
    type: DATAFLOW_PUBLISHING_DETAIL_LAYOUT_ANNOTATIONS_ITEMS_PAGE_RESET
});

export const readLinkedDataflowSourceDsdForLayoutAnnotations = (endpointId, dsdTriplet) => getRequest(
    DATAFLOW_PUBLISHING_DETAIL_LINKED_SOURCE_DSD_FOR_LAYOUT_ANNOTATIONS_READ,
    getDsdUrl(dsdTriplet, true),
    undefined,
    undefined,
    endpointId
);

export const readLinkedDataflowSourceDataflow = (endpointId, dataflowTriplet) => ({
    ...getRequest(
        DATAFLOW_PUBLISHING_DETAIL_LINKED_DATAFLOW_SOURCE_READ,
        getDataflowUrl(dataflowTriplet),
        undefined,
        undefined,
        endpointId
    ),
    endpointId
});

export const readDataflowsDetailHierarchicalCodelists = () => getRequest(
    DATAFLOW_PUBLISHING_DETAIL_HIERARCHICAL_CODELISTS_READ,
    getHierarchicalCodelistUrl()
);
